/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerRiskClasses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Risk Classes
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 04:45:03 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    RISKCLASS_LIST_CONTAINER_LOADED,
    RISKCLASS_LIST_CONTAINER_UNLOADED,
    RISKCLASS_LIST_TABLE_LOADED,
    RISKCLASS_LIST_TABLE_UNLOADED,

    RISKCLASS_SELECT_ROW,
    RISKCLASS_ADD,
    RISKCLASS_EDIT,
    RISKCLASS_DELETE,
    RISKCLASS_OPEN_WARNING,
    RISKCLASS_CLOSE_WARNING,

    RISKCLASS_EDIT_CONTAINER_LOADED,
    RISKCLASS_EDIT_CONTAINER_UNLOADED,
    RISKCLASS_EDIT_FORM_LOADED,
    RISKCLASS_EDIT_FORM_UNLOADED,
    RISKCLASS_EDIT_DATA_LOAD,
    RISKCLASS_EDIT_CONTAINER_SUBMIT,
    RISKCLASS_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeRiskClasses';

const defaultState = {
    refreshList: false,
    danger: false,
    riskclassid: 0,
    classid: 0,
    exposure: '',
    mitigation: '',
    inspection: '',
    replacement: '',
    color: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case RISKCLASS_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                riskclasses: action.payload[0] ? action.payload[0].records : null
            }
        case RISKCLASS_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case RISKCLASS_SELECT_ROW:
            return {
                ...state,
                riskclassid: action.id
            }
        case RISKCLASS_ADD:
            return {
                ...state
            }
        case RISKCLASS_EDIT:
            return {
                ...state,
                riskclassid: action.id
            }
        case RISKCLASS_DELETE:
            return {
                ...state,
                riskclassid: null
            }
        case RISKCLASS_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case RISKCLASS_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case RISKCLASS_EDIT_CONTAINER_LOADED:
        case RISKCLASS_EDIT_DATA_LOAD:
            return {
                ...state,
                riskclassid: action.payload[0] ? action.payload[0].riskclassid : 0,
                classid: action.payload[0] ? action.payload[0].classid : 0,
                exposure: action.payload[0] ? action.payload[0].exposure : '',
                mitigation: action.payload[0] ? action.payload[0].mitigation : '',
                inspection: action.payload[0] ? action.payload[0].inspection : '',
                replacement: action.payload[0] ? action.payload[0].replacement : '',
                color: action.payload[0] ? action.payload[0].color : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case RISKCLASS_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case RISKCLASS_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case RISKCLASS_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case RISKCLASS_LIST_CONTAINER_UNLOADED:
        case RISKCLASS_LIST_TABLE_UNLOADED:
        case RISKCLASS_EDIT_CONTAINER_UNLOADED:
        case RISKCLASS_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerRiskClasses.js